import { importAllWithReload } from '@tyro/core/utils';
import type { TFunction } from '@tyro/i18n';
import type { NavObjectFunction } from '@tyro/router/types';
import { getShellRoutes } from './routes';

const featureRouteImports: Array<
  () => Promise<{ getRoutes: NavObjectFunction }>
> = [
  () => import('@tyro/calendar/routes'),
  () => import('@tyro/notice-board/routes'),
  () => import('@tyro/class-list-manager/routes'),
  () => import('@tyro/groups/routes'),
  () => import('@tyro/attendance/routes'),
  () => import('@tyro/mail/routes'),
  () => import('@tyro/fees/routes'),
  () => import('@tyro/info-requests/routes'),
  () => import('@tyro/assessments/routes'),
  () => import('@tyro/school-activities/routes'),
  () => import('@tyro/room-booking/routes'),
  () => import('@tyro/people/routes'),
  () => import('@tyro/reporting/routes'),
  () => import('@tyro/templates/routes'),
  () => import('@tyro/sms/routes'),
  () => import('@tyro/subject-options/routes'),
  () => import('@tyro/substitution/routes'),
  () => import('@tyro/ana/routes'),
  () => import('@tyro/timetable/routes'),
  () => import('@tyro/tyro-tuition/routes'),
  () => import('@tyro/printing/routes'),
  () => import('@tyro/forms/routes'),
  () => import('@tyro/rules/routes'),
  () => import('@tyro/drives/routes'),
  () => import('@tyro/settings/routes'),
  () => import('@tyro/tyro-admin/routes'),
  () => import('@tyro/documentation/routes'),
];

async function loadAllFeatureRoutes() {
  if (process.env.NODE_ENV === 'production') {
    // Recovers a stale tab whose orphaned chunk would otherwise white-screen the
    // whole app on bootstrap.
    return importAllWithReload(featureRouteImports);
  }

  // Sequential in dev to avoid "factory is undefined" errors
  // from the dev server not having built all chunks yet
  // (dev chunk misses are transient, handled by the router's retry).
  const modules: { getRoutes: NavObjectFunction }[] = [];
  for (const load of featureRouteImports) {
    modules.push(await load());
  }
  return modules;
}

export async function getNavCategories(t: TFunction<'navigation'[]>) {
  const modules = await loadAllFeatureRoutes();
  return [...getShellRoutes(t), ...modules.flatMap((m) => m.getRoutes(t))];
}
